import { createApp, configureCompat } from 'vue';
import App from './App.vue';
import router from './router';
import VueCookies from 'vue-cookies';
import VueGtm from 'vue-gtm';

configureCompat({
  COMPONENT_ASYNC: false
});

const app = createApp(App);
app.use(router);
app.use(VueGtm, {
  id: process.env.VUE_APP_GTM_ID,
  enabled: true,
  debug:
    process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging',
  vueRouter: router
});
app.use(VueCookies);

app.mount('#app');
